const QyMessageBlack = {
    path: 'qyMessageBlack',
    component: resolve => require(['@/pages/admin/message/qyMessageBlack/list.vue'], resolve)
}

export default QyMessageBlack